import {Loader2, MapPin} from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export type LocationRequiredDialogProps = {
  open: boolean;
  isRechecking?: boolean;
  showReloadHint?: boolean;
  onRecheck: () => void;
  onDismiss: () => void;
};

export function LocationRequiredDialog({
  open,
  isRechecking = false,
  showReloadHint = false,
  onRecheck,
  onDismiss,
}: LocationRequiredDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onDismiss();
        }
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <MapPin className="size-4 shrink-0" />
            Location required
          </AlertDialogTitle>
          <AlertDialogDescription>
            Turn on location for this app in your device Settings, then return here and tap
            Continue. You can dismiss this and keep browsing — GPS forms stay unavailable until
            location is enabled.
          </AlertDialogDescription>
        </AlertDialogHeader>

        {showReloadHint ? (
          <p className="text-muted-foreground text-sm">
            If you already enabled location, the app will reload to pick it up — especially on
            iPhone.
          </p>
        ) : null}

        <AlertDialogFooter>
          <AlertDialogCancel type="button" className="w-full sm:w-auto" disabled={isRechecking}>
            Not now
          </AlertDialogCancel>
          <AlertDialogAction
            type="button"
            className="w-full sm:w-auto"
            disabled={isRechecking}
            onClick={(event) => {
              event.preventDefault();
              onRecheck();
            }}
          >
            {isRechecking ? <Loader2 className="size-4 animate-spin" /> : null}
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
